<template>
  <div class="d-flex flex-column">
    <div
      class="d-flex flex-row align-items-center"
      :class="{ [wc]: true }"
      v-if="bcTop"
      style="padding: 0.5em 2em; padding-bottom: 0"
    >
      <div
        class="breadcrumbs d-flex flex-row justify-content-start align-items-center"
      >
        <router-link to="" class="breadcrumb-item" :is="'span'">
          {{ $router.history.current.path.split("/")[1] | capitalize }}
        </router-link>
        <i class="ri-arrow-right-s-line"></i>
        <router-link to="" class="breadcrumb-item">
          {{ label }}
        </router-link>
        <i
          class="ri-arrow-right-s-line"
          :class="{ 'd-none': view === 'list' }"
        ></i>
        <router-link
          to=""
          class="breadcrumb-item"
          :class="{ 'd-none': view === 'list' }"
          :is="'span'"
        >
          {{ labelView }} {{ label }}
        </router-link>
      </div>
    </div>
    <div
      class="d-flex flex-row align-items-center justify-content-between toolbar-row"
      :class="{
        'mb-5': showBreadcrumb || showFilter,
        'toolbar-wrapper-fixed': sticky,
        'bg-white': sticky && isScrolling,
        [wc]: true,
      }"
    >
      <slot name="toolbar-left">
        <div
          v-if="showBreadcrumb"
          class="breadcrumbs toolbar-left d-flex flex-row justify-content-start align-items-center"
        >
          <router-link to="/" class="breadcrumb-item">
            <i class="ri-home-4-line"></i>
          </router-link>
          <i class="ri-arrow-drop-right-line"></i>
          <router-link to="" class="breadcrumb-item" :is="'span'">
            <i
              v-if="$_sys.breadcrumbIcons(currentPathSplitted[1])"
              :class="$_sys.breadcrumbIcons(currentPathSplitted[1])"
            ></i>
            {{ currentPathSplitted[1] | capitalize }}
          </router-link>
          <i class="ri-arrow-drop-right-line"></i>
          <router-link
            v-if="currentPathSplitted.length > 3"
            to=""
            class="breadcrumb-item"
            :is="'span'"
          >
            <i
              v-if="$_sys.breadcrumbIcons(currentPathSplitted[2])"
              :class="$_sys.breadcrumbIcons(currentPathSplitted[2])"
            ></i>
            {{ currentPathSplitted[2] | capitalize }}
          </router-link>
          <i
            v-if="currentPathSplitted.length > 3"
            class="ri-arrow-drop-right-line"
          ></i>
          <router-link to="" class="breadcrumb-item">
            <i
              v-if="$_sys.breadcrumbIcons(label)"
              class="text-primary"
              :class="$_sys.breadcrumbIcons(label)"
            ></i>
            {{ label }}
          </router-link>
          <i
            :class="{ 'd-none': view === 'list' }"
            class="ri-arrow-drop-right-line"
          ></i>
          <router-link
            to=""
            class="breadcrumb-item"
            :is="'span'"
            :class="{ 'd-none': view === 'list' }"
          >
            {{ labelView }} {{ label }}
          </router-link>
        </div>
      </slot>
      <div
        class="d-flex flex-column justify-content-center toolbar-right"
        v-if="showFilter"
      >
        <div
          class="d-flex flex-row align-items-start justify-content-center justify-content-lg-end mx-0"
        >
          <v-select
            class="v-select-global-filter"
            :clearable="false"
            :searchable="false"
            :value="$store.state.program_year"
            :options="$store.state.year_options"
            :loading="isLoadingChangeRoles"
            @input="onChangeProgramYear"
          ></v-select>
          <v-select
            v-if="$store.state.program_year && $store.state.role_code"
            class="v-select-global-filter ml-2 role"
            style="min-width: 150px"
            :clearable="false"
            :searchable="false"
            :value="{
              label: $store.state.role_name || $store.state.role_code,
              id: $store.state.role_code,
            }"
            :options="roleOptions"
            :loading="isLoadingChangeRoles"
            @open="initialDataRoleOption"
            @option:selected="onChangeUserRole($event)"
          ></v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "toolbar",
  props: {
    bcTop: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    wc: {
      type: String,
      required: false,
      default: () => "",
    },
    label: {
      type: String,
      required: false,
      default: () => "",
    },

    showBreadcrumb: {
      type: Boolean,
      required: false,
      default: () => true,
    },

    showFilter: {
      type: Boolean,
      required: false,
      default: () => true,
    },

    view: {
      type: String,
      required: true,
    },

    sticky: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      productionUnits: [],
      selectedUP: {},
      // selectedUP: this.$store.state.production_unit.id,
      isScrolling: false,
      roleOptions: [],
      isLoadingChangeRoles: false,
    };
  },

  computed: {
    productionUnit() {
      return this.$store.state.production_unit;
    },

    labelView() {
      const labels = {
        create: "Tambah",
        detail: "Detail",
        list: "Daftar",
        update: "Edit",
      };
      if (!this.view) return;
      return labels[this.view];
    },

    currentPathSplitted() {
      return this.$router.history.current.path.split("/");
    },
  },

  mounted() {
    if (this.sticky) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },

  destroyed() {
    if (this.sticky) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },

  methods: {
    onClear() {},
    handleScroll(event) {
      // console.log("Scroll", event.target.scrollingElement.scrollTop);
      if (event.target.scrollingElement.scrollTop > 50) {
        this.isScrolling = true;
      } else {
        this.isScrolling = false;
      }
    },
    async onChange(value) {
      if (value.id !== this.productionUnit.id && value.id !== null) {
        // this.$_api
        //   .get(`/view/production-unit/${value.id}`)
        //   .then(async (response) => {
        //     const puModel = {
        //       id: response.data.id,
        //       code: response.data.code,
        //       name: response.data.name,
        //       phone: response.data.phone,
        //       email: response.data.email,
        //       address: response.data.address,
        //       description: response.data.description
        //     }
        const puModel = value;
        // this.productionUnits = puModel

        this.$store.commit("set", ["production_unit", puModel, true]);
        this.$store.commit("set", ["temporary_up_id", value.id, true]);
        await this.$store.dispatch("setModule");
        this.$emit("change", puModel);
        // this.rerenderComponent()
        // })
      } else if (value.id === null && value.id !== this.productionUnit.id) {
        let puModel = {
          id: "",
          code: "",
          name: "Semua Unit Produksi",
          phone: "",
          email: "",
          address: "",
          description: "",
        };

        this.$store.commit("set", ["production_unit", puModel, true]);
        this.$store.commit("set", ["temporary_up_id", "", true]);
        await this.$store.dispatch("setModule");
        this.$emit("change", puModel);
      } else {
      }
    },
    onChangeProgramYear: async function (value) {
      try {
        this.isLoadingChangeRoles = true;
        // update $store.program_year
        this.$store.commit("set", ["program_year", value, true]);
        // reset user role
        // const { data: dataUserRoles } = await this.$_api.dataset("user_roles", {
        //   user_id: this.$_sys.userInfo().id,
        //   program_year: this.$store.state.program_year,
        // });
        // if (
        //   dataUserRoles.length
        // ) {
        //   this.$store.commit("set", ["role_code", dataUserRoles[0].role_code, true]);
        // } else {
        //   localStorage.clear();
        //   this.$router.push({ name: "login" });

        //   return;
        // }

        // refresh module
        await this.$store.dispatch("setModule");
      } catch (err) {
        console.log("onChangeProgramYear error", err);
        this.$_alert.error(err);
      } finally {
        this.isLoadingChangeRoles = false;
      }
    },
    onChangeUserRole: async function (value) {
      try {
        this.isLoadingChangeRoles = true;

        // switch token
        const e = await this.$_api.post("/login/switch", {
          role_code: value.role_code,
        });
        if (e && e.token) {
          this.$store.commit("set", ["", e.user, true]);
          this.$store.commit("set", ["profile", e.user, true]);
          this.$store.commit("set", ["_token", e.token, true]);
          this.$store.commit("set", ["permission", e.tasks, true]);
          this.$store.commit("set", ["program_year", e.program_year, true]);
        }
        // update $store.program_year
        this.$store.commit("set", ["role_code", value.role_code, true]);
        this.$store.commit("set", ["role_name", value.role_name, true]);
        // refresh module
        await this.$store.dispatch("setModule");
      } catch (err) {
        console.log("onChangeUserRole error", err);
      } finally {
        this.isLoadingChangeRoles = false;
      }
    },
    getInitialUP() {
      this.$_api
        .get("/lookup/production-unit")
        .then((response) => {
          const results = response.data.data.map((item) => {
            let _val = item;
            _val.label = item.name;
            _val.id = item.id;
            return _val;
          });

          results.unshift({
            label: "Semua Unit Produksi",
            value: null,
          });

          this.productionUnits = results;
        })
        .catch(() => {});
    },
    initialDataRoleOption() {
      this.isLoadingChangeRoles = true;
      let params = {
        program_year: this.$store.state.program_year,
        user_id: this.$_sys.userInfo().id,
        limit: 100,
      };

      this.$_api
        .dataset("user_roles", params)
        .then((res) => {
          console.log("res", res);
          const result = res.data.map((item) => {
            let _val = item;
            _val.label = item.role_name;
            _val.id = item.role_code;
            return _val;
          });
          this.roleOptions = result;
        })
        .catch((err) => {
          console.log("initialDataRoleOption() err", err);
          this.$_alert.error(err);
        })
        .finally(() => {
          this.isLoadingChangeRoles = false;
        });
    },
    onSearch(search, loading) {
      loading(true);
      this.$_api
        .get("/lookup/production-unit", { search: search })
        .then((response) => {
          const results = response.data.data.map((item) => {
            let _val = item;
            _val.label = item.name;
            _val.id = item.id;
            return _val;
          });

          results.unshift({
            label: "Semua Unit Produksi",
            value: null,
          });

          this.productionUnits = results;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    },
  },

  watch: {
    // 'productionUnit.id' (val) {
    //     if (val) {
    //         this.$_api.get(`/view/production-unit/${val}`)
    //             .then(async(response) => {
    //             const puModel = {
    //                 id: response.data.id,
    //                 code: response.data.code,
    //                 name: response.data.name,
    //                 phone: response.data.phone,
    //                 email: response.data.email,
    //                 address: response.data.address,
    //                 description: response.data.description,
    //             }
    //             this.productionUnit = puModel
    //             this.$store.commit('set', ['production_unit', puModel, true])
    //             await this.$store.dispatch('setModule')
    //             this.rerenderComponent()
    //             })
    //     }
    // },
  },
};
</script>

<style scoped>
.toolbar-wrapper-fixed {
  position: sticky;
  top: 0;
  z-index: 999;
  transform: all 0.25s ease;
  padding: 1em 2em;
}

.toolbar-wrapper-fixed.bg-white {
  background: #fff;

  transform: all 0.25s ease;
}

.toolbar-right {
  width: 30%;
}

.toolbar-left {
  display: flex;
}

/* vue-select custom */
.v-select-global-filter {
  min-width: 85px;
  .vs__selected-options {
    padding: 3px 2px;
  }
  .vs__search {
    /* background-color: blue; */
  }
  &.role .vs__selected {
    /* font-size: 7px; */
    text-wrap: nowrap;
  }
}
>>> {
  /* Search Input */
  --vs-search-input-bg: #f2f9f5;

  --vs-controls-color: #226638;
  --vs-border-color: #226638;

  --vs-dropdown-bg: #f2f9f5;
  /* --vs-dropdown-color: #cc99cd; */
  /* --vs-dropdown-option-color: #cc99cd; */

  --vs-selected-bg: #f2f9f5;
  --vs-selected-color: #226638;

  /* --vs-search-input-color: #eeeeee; */

  --vs-dropdown-option--active-bg: #226638;
  --vs-dropdown-option--active-color: #fff;
}

@media only screen and (max-width: 576px) {
  .toolbar-right {
    width: auto;
  }

  .toolbar-left {
    flex: 1;
  }

  .toolbar-row {
    flex-wrap: wrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/component/toolbar.vue